import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { ICategorie, ICategorieForm, ICategorieUpdatePayload } from '../categorii-proiecte.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CategoriiProiecteService } from '../categorii-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
    selector: 'app-edit-categorii-proiecte',
    templateUrl: './edit-categorii-proiecte.component.html',
    styleUrls: ['./edit-categorii-proiecte.component.scss']
})
export class EditCategoriiProiecteComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    sections$!: Observable<Generic[]>;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        sectiune: new FormControl(this.data.id_section, []),
        observatii: new FormControl(this.data.observatii, []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: ICategorie,
        private dialogRef: MatDialogRef<EditCategoriiProiecteComponent>,
        private categoriiProiecteService: CategoriiProiecteService,
        private notificationService: NotificationService,
        private commonService: CommonService,
    ) { }

    ngOnInit(): void {
        this.loadSectiuniProiecte();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    loadSectiuniProiecte() {
        this.isLoading = true;
        this.sections$ = this.commonService.getSectiuniProiecte().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    submitForm() {
        this.isLoading = true;

        const {
            name,
            observatii,
            sectiune,
        } = this.form.value as ICategorieForm;
        const payload: ICategorieUpdatePayload = {
            id_categorie: this.data.id,
            name,
            observatii,
            id_section: sectiune,
        };

        this.categoriiProiecteService
            .updateCategorie(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
